import React from "react"
import InputTextareaForm from "../../../components/molecules/InputTextareaForm.molecule"
import { splitQuestionTextOptionalLabel } from "../../../utils/survey.utils"

export default function TextQuestion({
  question,
  value = {},
  updateAnswer,
  error,
  onClearError,
}) {
  const [questionText, optionalLabel] = splitQuestionTextOptionalLabel(
    question.questionText
  )

  const handleChange = (e) => {
    updateAnswer(question.questionId, "text", e.target.value)

    if (error && onClearError) {
      onClearError()
    }
  }

  return (
    <div className="w-full">
      <div className="survey-question-header">
        <span className="font-mulish survey-question-text">{questionText}</span>
        {optionalLabel && (
          <span className="font-mulish survey-optional-text">
            {` ${optionalLabel}`}
          </span>
        )}
        {error && (
          <span className="font-mulish survey-error-text "> {error}</span>
        )}
      </div>

      <InputTextareaForm
        name={`question-${question.questionId}`}
        value={value?.text || ""}
        onChange={handleChange}
        rows={1}
        autoResize={true}
        autoTrim={false}
        maxLength={600}
        error={[]}
        className={`w-full ${error ? "survey-error-border" : ""}`}
      />
    </div>
  )
}
